module.exports = __webpack_public_path__ + "static/media/NotANotB.a51cc68a.jpg";